export default __webpack_public_path__ + "static/media/Layout t2 - Segregação Arm.01 rev 22.d753a00d.pdf";